import { useState } from 'react'

import { Box, CollapsableCard, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { ComparisonPlan } from 'modules/onboarding/lib/pricing/types'

import FeatureRow from './_FeatureRow'
import styles from './index.module.css'

type Props = {
  plan: ComparisonPlan
  index: number
}

const FeatureCompareTable = ({ plan, index }: Props) => {
  const [isOpen, setIsOpen] = useState(index === 0)

  return (
    <CollapsableCard
      contentBackground="grey000White"
      open={isOpen}
      Card={
        <Box
          cursor="pointer"
          flexDirection="row"
          justifyContent="spaceBetween"
          alignItems="center"
          paddingX="s8"
          onClick={() => {
            setIsOpen(!isOpen)
          }}
        >
          <Text size="300" weight="medium">
            {plan.title}
          </Text>
          <Box flexDirection="row" gap="s16" alignItems="center">
            <Icon.Medium icon={isOpen ? 'chevron-up' : 'chevron-down'} />
          </Box>
        </Box>
      }
      Content={
        <Box className={styles.tableWrapper} paddingBottom="s24">
          <table className={styles.comparisonTable}>
            <thead>
              <tr>
                <th></th>
                <th className="bg-neutral-5 py-xs border border-neutral-10 px-xs">
                  <span>{i18n.t('pricing_plans.comparison_table.header.business')}</span>
                </th>
                <th className="bg-neutral-5 py-xs border border-neutral-10 px-xs">
                  <span>{i18n.t('pricing_plans.comparison_table.header.enterprise')}</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {plan.features.map((feature) => (
                <tr
                  key={`${feature.title}-${feature.business}`}
                  className="border-b border-neutral-10"
                >
                  <FeatureRow {...feature} />
                </tr>
              ))}
            </tbody>
          </table>
        </Box>
      }
    />
  )
}

export default FeatureCompareTable
